import { Col, message, Row, Space, Spin, Table, Tag } from "antd";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ResponsiveBar } from "@nivo/bar";
import { ResponsiveLine } from "@nivo/line";
import { ResponsivePie } from "@nivo/pie";
import { ButtonItem, ErrorItem, Form, TableItemDinamico } from "../../../../Components/Items";
import ModalVerRegistroProceso from "../Modales/ModalVerRegistroProceso";
import FiltrosCalidad from "./FiltrosCalidad";
import {
  descargarPdfCalidad,
  exportarExcel,
  fmtDuracion,
  fmtFecha,
  fmtFraccion,
  fmtResultado,
} from "./exportCalidad";
import {
  ChartCard,
  COLOR_RESULTADO,
  COLORES_RESULTADO,
  colorPorcentaje,
  EstadoVacio,
  fmtDiaCorto,
  isMobile,
  KpiRow,
  NIVO_THEME,
  ordenarPorClave,
  RESULTADO_LABEL,
  RESULTADO_TAG,
  tagPorcentaje,
  TooltipCalidad,
} from "./reporteCalidadStyles";

const PERIODO_INICIAL = { periodo: [moment().subtract(1, "month"), moment()] };

const TIPO_LABEL = { EMPLEADO: "Empleado", CLIENTE: "Cliente", USUARIO: "Usuario" };

const recortar = (texto, largo) =>
  texto && texto.length > largo ? `${texto.substring(0, largo)}…` : texto;

class ReporteColaborador extends Component {
  formRef = React.createRef();
  tableRef = null;

  state = {
    loading: false,
    registros: [],
    totalRegistros: 0,
    resumen: null,
    colaborador: null,
    porPrograma: [],
    porProceso: [],
    peoresCriterios: [],
    empresa: null,
    currentFilters: {},
    modalVerRegistroPdf: false,
    registroIdPdf: null,
  };

  buildPayload(values = {}) {
    const payload = {};
    if (values.ejecutadoPor) payload.ejecutadoPor = values.ejecutadoPor;
    if (values.programaId) payload.programaId = values.programaId;
    if (values.periodo?.length === 2) {
      payload.fechaInicio = values.periodo[0].startOf("day").toISOString();
      payload.fechaFin = values.periodo[1].endOf("day").toISOString();
    }
    return payload;
  }

  onFetchData(params) {
    if (!params.ejecutadoPor) return;

    this.setState({ loading: true });
    axios
      .post(
        "programa/reporteColaborador",
        { empresaId: this.props.empresaId, ...params },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            registros: res.data.data,
            totalRegistros: res.data.totalRecords,
            resumen: res.data.resumen,
            colaborador: res.data.colaborador,
            porPrograma: res.data.porPrograma ?? [],
            porProceso: res.data.porProceso ?? [],
            peoresCriterios: res.data.peoresCriterios ?? [],
            empresa: res.data.empresa ?? null,
          });
        } else {
          message.error(res.data.message ?? "No se pudo generar el reporte");
        }
      })
      .catch(() => message.error("Error de conexión"))
      .finally(() => this.setState({ loading: false }));
  }

  consultarReporte(values) {
    const payload = this.buildPayload(values);
    this.setState({ currentFilters: payload });
    this.tableRef?.updateExternalFilters(payload);
  }

  async fetchAll() {
    const res = await axios.post(
      "programa/reporteColaborador",
      { empresaId: this.props.empresaId, ...this.state.currentFilters },
      { headers: this.props.headersToken }
    );
    if (res.data.success !== 2) throw new Error("Error al obtener datos");
    return res.data;
  }

  async descargarExcel() {
    this.setState({ loading: true });
    try {
      const { data: registros, resumen } = await this.fetchAll();
      exportarExcel(
        "Reporte_Colaborador_Calidad",
        "Colaborador",
        registros.map((r) => ({
          Programa: r.programa?.nombre ?? "-",
          Proceso: r.proceso?.nombre ?? "-",
          Resultado: fmtResultado(r.resultado),
          "Fecha inicio": fmtFecha(r.fechaInicio),
          "Fecha fin": fmtFecha(r.fechaFin),
          "Duración (min)": r.duracionMinutos ?? "-",
          ...(resumen?.usaPuntos
            ? { Puntos: fmtFraccion(r.puntosCompletados, r.puntosTotales) }
            : {}),
          ...(resumen?.usaPasos ? { Pasos: fmtFraccion(r.pasosCompletados, r.pasosTotales) } : {}),
          ...(resumen?.usaCriterios
            ? { Criterios: fmtFraccion(r.criteriosCumplidos, r.criteriosTotales) }
            : {}),
          "% Cumplimiento": r.porcentajeCumplimiento != null ? `${r.porcentajeCumplimiento}%` : "-",
          Observaciones: r.observaciones || "",
        }))
      );
    } catch {
      message.error("No se pudo generar el Excel");
    } finally {
      this.setState({ loading: false });
    }
  }

  async descargarPdf() {
    this.setState({ loading: true });
    try {
      const {
        data: registros,
        resumen,
        empresa,
        colaborador,
        porPrograma,
        porProceso,
        peoresCriterios,
      } = await this.fetchAll();
      const { usaPuntos, usaPasos, usaCriterios } = resumen ?? {};

      const columnasDesglose = [
        "Nombre",
        "Registros",
        "Compl.",
        "Con obs.",
        "Rechaz.",
        "% Cumpl.",
        "% Criterios",
        "Dur. prom.",
      ];
      const widthsDesglose = ["*", 56, 46, 52, 50, 56, 62, 58];
      const filasDesglose = (lista) =>
        lista.map((g) => [
          g.nombre,
          { text: `${g.total}`, alignment: "center" },
          { text: `${g.completados}`, alignment: "center" },
          { text: `${g.conObservaciones}`, alignment: "center" },
          { text: `${g.rechazados}`, alignment: "center" },
          { text: `${g.porcentajeCumplimiento}%`, alignment: "center", bold: true },
          { text: usaCriterios ? `${g.porcentajeCriterios}%` : "-", alignment: "center" },
          { text: fmtDuracion(g.duracionPromedioMinutos), alignment: "center" },
        ]);

      descargarPdfCalidad({
        empresa,
        titulo: "Reporte por Colaborador",
        subtitulo: colaborador?.nombre ?? "-",
        extras: [
          `Tipo: ${TIPO_LABEL[colaborador?.tipo] ?? colaborador?.tipo ?? "-"}`,
          `Total registros: ${registros.length}`,
        ],
        nombreArchivo: "Reporte_Colaborador_Calidad",
        kpis: [
          { label: "Registros", value: resumen?.total ?? 0 },
          { label: "Completados", value: resumen?.completados ?? 0 },
          { label: "Con obs.", value: resumen?.conObservaciones ?? 0 },
          { label: "Rechazados", value: resumen?.rechazados ?? 0 },
          { label: "% Cumplimiento", value: `${resumen?.porcentajeCumplimiento ?? 0}%` },
          usaPuntos && { label: "% Puntos", value: `${resumen?.porcentajePuntos ?? 0}%` },
          usaCriterios && { label: "% Criterios", value: `${resumen?.porcentajeCriterios ?? 0}%` },
          {
            label: "Dur. promedio",
            value:
              resumen?.duracionPromedioMinutos != null
                ? `${resumen.duracionPromedioMinutos} min`
                : "-",
          },
        ],
        secciones: [
          {
            titulo: `Desglose por programa (${porPrograma.length})`,
            columnas: columnasDesglose,
            widths: widthsDesglose,
            filas: filasDesglose(porPrograma),
          },
          {
            titulo: `Desglose por proceso (${porProceso.length})`,
            columnas: columnasDesglose,
            widths: widthsDesglose,
            filas: filasDesglose(porProceso),
          },
          {
            titulo: "Criterios que más le fallan",
            columnas: ["Criterio", "Punto de control", "Evaluaciones", "No cumplidos", "%"],
            widths: ["*", "*", 62, 62, 34],
            filas: (peoresCriterios ?? []).map((c) => [
              c.criterio,
              c.punto,
              { text: `${c.evaluaciones}`, alignment: "center" },
              { text: `${c.noCumplidos}`, alignment: "center" },
              { text: `${c.porcentaje}%`, alignment: "center", bold: true },
            ]),
            vacio: "Cumplió el 100% de los criterios evaluados.",
          },
          {
            titulo: `Registros ejecutados (${registros.length})`,
            columnas: [
              "Programa",
              "Proceso",
              "Resultado",
              "Inicio",
              "Fin",
              "Duración",
              ...(usaPuntos ? ["Puntos"] : []),
              ...(usaPasos ? ["Pasos"] : []),
              ...(usaCriterios ? ["Criterios"] : []),
            ],
            widths: [
              "*", "*", 60, 50, 50, 38,
              ...(usaPuntos ? [40] : []),
              ...(usaPasos ? [40] : []),
              ...(usaCriterios ? [46] : []),
            ],
            filas: registros.map((r) => [
              r.programa?.nombre ?? "-",
              r.proceso?.nombre ?? "-",
              { text: fmtResultado(r.resultado), bold: true },
              fmtFecha(r.fechaInicio),
              fmtFecha(r.fechaFin),
              { text: fmtDuracion(r.duracionMinutos), alignment: "center" },
              ...(usaPuntos
                ? [{ text: fmtFraccion(r.puntosCompletados, r.puntosTotales), alignment: "center" }]
                : []),
              ...(usaPasos
                ? [{ text: fmtFraccion(r.pasosCompletados, r.pasosTotales), alignment: "center" }]
                : []),
              ...(usaCriterios
                ? [
                    {
                      text: fmtFraccion(r.criteriosCumplidos, r.criteriosTotales),
                      alignment: "center",
                    },
                  ]
                : []),
            ]),
          },
        ],
      });
    } catch {
      message.error("No se pudo generar el PDF");
    } finally {
      this.setState({ loading: false });
    }
  }

  kpis() {
    const { resumen } = this.state;
    if (!resumen) return [];
    return [
      { key: "total", label: "Registros ejecutados", value: resumen.total, color: "#0f172a" },
      { key: "completados", label: "Completados", value: resumen.completados, color: COLOR_RESULTADO.completado },
      { key: "conObs", label: "Con obs.", value: resumen.conObservaciones, color: COLOR_RESULTADO.completado_con_observaciones },
      { key: "rechazados", label: "Rechazados", value: resumen.rechazados, color: COLOR_RESULTADO.rechazado },
      {
        key: "cumplimiento",
        label: "% Cumplimiento",
        value: `${resumen.porcentajeCumplimiento}%`,
        color: colorPorcentaje(resumen.porcentajeCumplimiento),
      },
      resumen.usaCriterios && {
        key: "criterios",
        label: "% Criterios",
        value: `${resumen.porcentajeCriterios}%`,
        color: "#6366f1",
        hint: `${resumen.totalCriteriosCumplidos}/${resumen.totalCriterios}`,
      },
      resumen.usaPuntos && {
        key: "puntos",
        label: "% Puntos compl.",
        value: `${resumen.porcentajePuntos}%`,
        color: "#0ea5e9",
        hint: `${resumen.totalPuntosCompletados}/${resumen.totalPuntos}`,
      },
      resumen.duracionPromedioMinutos != null && {
        key: "duracion",
        label: "Duración prom.",
        value: `${resumen.duracionPromedioMinutos} min`,
        color: "#8b5cf6",
      },
    ].filter(Boolean);
  }

  ficha() {
    const { colaborador, porPrograma, resumen } = this.state;
    if (!colaborador) return null;

    const ultima = resumen
      ? [...(porPrograma ?? [])].sort((a, b) =>
          (b.ultimaEjecucion ?? "") > (a.ultimaEjecucion ?? "") ? 1 : -1
        )[0]?.ultimaEjecucion
      : null;

    const datos = [
      { label: "Tipo", valor: TIPO_LABEL[colaborador.tipo] ?? colaborador.tipo },
      { label: "Programas en los que participa", valor: `${porPrograma?.length ?? 0}` },
      { label: "Procesos distintos", valor: `${this.state.porProceso?.length ?? 0}` },
      { label: "Última ejecución", valor: ultima ? fmtFecha(ultima) : "-" },
    ];

    return (
      <div className="cal-ficha">
        <div className="cal-ficha-nombre">{colaborador.nombre}</div>
        <Row gutter={[16, 8]}>
          {datos.map((d) => (
            <Col key={d.label} xs={24} sm={12} md={6}>
              <div className="cal-ficha-dato">
                {d.label}: <b>{d.valor || "-"}</b>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    );
  }

  graficas() {
    const { resumen, porPrograma } = this.state;
    if (!resumen || resumen.total === 0) return null;

    const movil = isMobile();

    const dataPie = [
      { id: "Completado", label: "Completado", value: resumen.completados },
      { id: "Con obs.", label: "Con obs.", value: resumen.conObservaciones },
      { id: "Rechazado", label: "Rechazado", value: resumen.rechazados },
      { id: "Pendiente", label: "Pendiente", value: resumen.pendientes },
    ].filter((d) => d.value > 0);

    const dataProgramas = porPrograma.slice(0, 12).map((g) => ({
      programa: recortar(g.nombre, movil ? 10 : 16),
      programaCompleto: g.nombre,
      Completado: g.completados,
      "Con obs.": g.conObservaciones,
      Rechazado: g.rechazados,
      Pendiente: g.pendientes,
      cumplimiento: g.porcentajeCumplimiento,
    }));

    const dataLine = Object.entries(resumen.diasMap ?? {})
      .sort(ordenarPorClave)
      .map(([clave, { suma, n }]) => ({ x: fmtDiaCorto(clave), y: Math.round(suma / n) }));

    return (
      <>
        <Row gutter={[14, 14]} style={{ marginBottom: 14 }}>
          {dataPie.length > 0 && (
            <Col xs={24} md={9}>
              <ChartCard
                label="Resultados"
                titulo="Resultados del colaborador"
                pill={`${resumen.total} registros`}
                delay={0.06}
                altura={250}
              >
                <ResponsivePie
                  data={dataPie}
                  margin={
                    movil
                      ? { top: 10, right: 10, bottom: 40, left: 10 }
                      : { top: 10, right: 20, bottom: 46, left: 20 }
                  }
                  colors={COLORES_RESULTADO}
                  innerRadius={0.67}
                  padAngle={1.8}
                  cornerRadius={6}
                  activeOuterRadiusOffset={9}
                  borderWidth={0}
                  enableArcLabels={false}
                  arcLinkLabelsSkipAngle={movil ? 360 : 14}
                  arcLinkLabelsTextColor="#94a3b8"
                  arcLinkLabelsThickness={1}
                  arcLinkLabelsColor={{ from: "color" }}
                  theme={NIVO_THEME}
                  legends={[
                    {
                      anchor: "bottom",
                      direction: "row",
                      translateY: 42,
                      itemsSpacing: 6,
                      itemWidth: movil ? 68 : 82,
                      itemHeight: 16,
                      itemTextColor: "#64748b",
                      symbolSize: 9,
                      symbolShape: "circle",
                    },
                  ]}
                  tooltip={({ datum }) => (
                    <TooltipCalidad
                      color={datum.color}
                      titulo={datum.label}
                      filas={[{ label: "Registros", value: datum.value }]}
                    />
                  )}
                />
              </ChartCard>
            </Col>
          )}

          {dataProgramas.length > 0 && (
            <Col xs={24} md={dataPie.length ? 15 : 24}>
              <ChartCard
                label="Desglose"
                titulo="Resultados por programa"
                pill={`${porPrograma.length} programas`}
                accent="linear-gradient(90deg, #f59e0b, #fbbf24)"
                delay={0.12}
                altura={250}
              >
                <ResponsiveBar
                  data={dataProgramas}
                  keys={["Completado", "Con obs.", "Rechazado", "Pendiente"]}
                  indexBy="programa"
                  margin={{ top: 10, right: 8, bottom: movil ? 76 : 66, left: 40 }}
                  padding={0.28}
                  innerPadding={2}
                  groupMode="stacked"
                  colors={COLORES_RESULTADO}
                  colorBy="id"
                  borderRadius={4}
                  axisTop={null}
                  axisRight={null}
                  axisBottom={{ tickSize: 0, tickPadding: 10, tickRotation: -35 }}
                  axisLeft={{ tickSize: 0, tickPadding: 8 }}
                  enableGridX={false}
                  gridYValues={4}
                  enableLabel={false}
                  theme={NIVO_THEME}
                  tooltip={({ id, value, color, data }) => (
                    <TooltipCalidad
                      color={color}
                      titulo={data.programaCompleto}
                      filas={[
                        { label: id, value },
                        { label: "% Cumplimiento", value: `${data.cumplimiento}%` },
                      ]}
                    />
                  )}
                  legends={
                    movil
                      ? []
                      : [
                          {
                            dataFrom: "keys",
                            anchor: "bottom",
                            direction: "row",
                            translateY: 60,
                            itemWidth: 96,
                            itemHeight: 16,
                            itemsSpacing: 4,
                            symbolSize: 8,
                            symbolShape: "circle",
                            itemTextColor: "#64748b",
                          },
                        ]
                  }
                />
              </ChartCard>
            </Col>
          )}
        </Row>

        {dataLine.length > 1 && (
          <Row style={{ marginBottom: 14 }}>
            <Col span={24}>
              <ChartCard
                label="Evolución"
                titulo="% de cumplimiento por día"
                accent="linear-gradient(90deg, #6366f1, #a78bfa)"
                delay={0.18}
                altura={210}
              >
                <ResponsiveLine
                  data={[{ id: "% Cumplimiento", data: dataLine }]}
                  margin={{ top: 10, right: 20, bottom: 54, left: 46 }}
                  xScale={{ type: "point" }}
                  yScale={{ type: "linear", min: 0, max: 100 }}
                  curve="monotoneX"
                  colors={["#6366f1"]}
                  lineWidth={2.5}
                  pointSize={6}
                  pointColor="#ffffff"
                  pointBorderWidth={2}
                  pointBorderColor={{ from: "serieColor" }}
                  enableArea
                  areaOpacity={0.08}
                  enableSlices="x"
                  enableGridX={false}
                  gridYValues={[0, 25, 50, 75, 100]}
                  theme={NIVO_THEME}
                  axisBottom={{
                    tickSize: 0,
                    tickPadding: 10,
                    tickRotation: -30,
                    tickValues: dataLine
                      .map((d) => d.x)
                      .filter((_, i) => i % Math.ceil(dataLine.length / (movil ? 6 : 12)) === 0),
                  }}
                  axisLeft={{ tickSize: 0, tickPadding: 8, format: (v) => `${v}%` }}
                  sliceTooltip={({ slice }) => (
                    <TooltipCalidad
                      color="#6366f1"
                      titulo={slice.points[0]?.data.x}
                      filas={[{ label: "Cumplimiento", value: `${slice.points[0]?.data.y}%` }]}
                    />
                  )}
                />
              </ChartCard>
            </Col>
          </Row>
        )}
      </>
    );
  }

  desgloses() {
    const { resumen, porPrograma, porProceso } = this.state;
    if (!resumen || resumen.total === 0) return null;

    const columnas = (tituloPrimera) =>
      [
        { title: tituloPrimera, dataIndex: "nombre", ellipsis: true },
        { title: "Registros", dataIndex: "total", align: "center", width: 90 },
        { title: "Compl.", dataIndex: "completados", align: "center", width: 80 },
        { title: "Rechaz.", dataIndex: "rechazados", align: "center", width: 80 },
        {
          title: "% Cumpl.",
          dataIndex: "porcentajeCumplimiento",
          align: "center",
          width: 95,
          render: (v) => <Tag color={tagPorcentaje(v)}>{v}%</Tag>,
        },
        resumen.usaCriterios && {
          title: "% Criterios",
          dataIndex: "porcentajeCriterios",
          align: "center",
          width: 105,
          render: (v) => <Tag color={tagPorcentaje(v)}>{v}%</Tag>,
        },
        {
          title: "Dur. prom.",
          dataIndex: "duracionPromedioMinutos",
          align: "center",
          width: 100,
          render: fmtDuracion,
        },
      ].filter(Boolean);

    return (
      <Row gutter={[14, 14]} style={{ marginBottom: 14 }}>
        <Col xs={24} xl={12}>
          <div className="cal-card" style={{ animationDelay: "0.22s" }}>
            <div className="cal-card-head">
              <div>
                <div className="cal-card-label">Desglose</div>
                <h2 className="cal-card-title">Por programa</h2>
              </div>
            </div>
            <div className="cal-card-accent" />
            <Table
              size="small"
              rowKey="id"
              dataSource={porPrograma}
              columns={columnas("Programa")}
              pagination={porPrograma.length > 8 ? { pageSize: 8, size: "small" } : false}
              scroll={{ x: "max-content" }}
            />
          </div>
        </Col>
        <Col xs={24} xl={12}>
          <div className="cal-card" style={{ animationDelay: "0.26s" }}>
            <div className="cal-card-head">
              <div>
                <div className="cal-card-label">Desglose</div>
                <h2 className="cal-card-title">Por proceso</h2>
              </div>
            </div>
            <div
              className="cal-card-accent"
              style={{ background: "linear-gradient(90deg, #0ea5e9, #38bdf8)" }}
            />
            <Table
              size="small"
              rowKey="id"
              dataSource={porProceso}
              columns={columnas("Proceso")}
              pagination={porProceso.length > 8 ? { pageSize: 8, size: "small" } : false}
              scroll={{ x: "max-content" }}
            />
          </div>
        </Col>
      </Row>
    );
  }

  columnasRegistros() {
    const { resumen } = this.state;
    return [
      { title: "Programa", key: "programa", render: (_, r) => r.programa?.nombre ?? "-", ellipsis: true },
      { title: "Proceso", key: "proceso", render: (_, r) => r.proceso?.nombre ?? "-", ellipsis: true },
      {
        title: "Resultado",
        dataIndex: "resultado",
        width: 140,
        render: (v) => <Tag color={RESULTADO_TAG[v] ?? "default"}>{RESULTADO_LABEL[v] ?? v}</Tag>,
      },
      { title: "Inicio", dataIndex: "fechaInicio", render: fmtFecha, width: 120 },
      { title: "Fin", dataIndex: "fechaFin", render: fmtFecha, width: 120 },
      {
        title: "Duración",
        dataIndex: "duracionMinutos",
        render: fmtDuracion,
        align: "center",
        width: 90,
      },
      resumen?.usaCriterios && {
        title: "Criterios ✓",
        key: "criterios",
        align: "center",
        width: 100,
        render: (_, r) => fmtFraccion(r.criteriosCumplidos, r.criteriosTotales),
      },
      {
        title: "% Cumpl.",
        dataIndex: "porcentajeCumplimiento",
        align: "center",
        width: 95,
        render: (v) => (v != null ? <Tag color={tagPorcentaje(v)}>{v}%</Tag> : "-"),
      },
      {
        title: "PDF",
        key: "pdf",
        align: "center",
        width: 70,
        render: (_, r) => (
          <ButtonItem
            size="small"
            naranja
            icon={<FilePdfOutlined />}
            tooltip="Ver PDF"
            onClick={() => this.setState({ modalVerRegistroPdf: true, registroIdPdf: r._id })}
          />
        ),
      },
    ].filter(Boolean);
  }

  render() {
    const { registros, totalRegistros, resumen, loading, currentFilters } = this.state;
    const sinColaborador = !currentFilters.ejecutadoPor;

    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteCalidadColaborador"
          onFinish={this.consultarReporte.bind(this)}
          onFinishFailed={ErrorItem}
          initialValues={PERIODO_INICIAL}
        >
          <Spin spinning={loading} wrapperClassName="cal-spin">
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
              <Space>
                {resumen && !sinColaborador && (
                  <ButtonItem
                    verde
                    onClick={() => this.descargarExcel()}
                    icon={<FileExcelOutlined />}
                  >
                    Excel
                  </ButtonItem>
                )}
                {resumen && !sinColaborador && (
                  <ButtonItem rojo onClick={() => this.descargarPdf()} icon={<FilePdfOutlined />}>
                    PDF
                  </ButtonItem>
                )}
                <ButtonItem type="primary" htmlType="submit">
                  Consultar
                </ButtonItem>
              </Space>
            </div>

            <FiltrosCalidad
              campos={["periodo", "colaborador", "programa"]}
              requeridos={["ejecutadoPor"]}
              formRef={this.formRef}
            />

            {sinColaborador && (
              <EstadoVacio
                titulo="Elige un colaborador"
                texto="Selecciona un colaborador y pulsa Consultar para ver su desempeño. La lista solo incluye a quienes tienen registros de calidad."
              />
            )}

            {!sinColaborador && (
              <>
                {this.ficha()}
                <KpiRow items={this.kpis()} />
                {this.graficas()}
                {this.desgloses()}
                {resumen && resumen.total === 0 && (
                  <EstadoVacio
                    titulo="Sin registros en el período"
                    texto="Este colaborador no ejecutó procesos en el rango de fechas seleccionado."
                  />
                )}
              </>
            )}

            <div
              style={{
                display: sinColaborador || (resumen && resumen.total === 0) ? "none" : "block",
              }}
            >
              <TableItemDinamico
                onRef={(ref) => (this.tableRef = ref)}
                totalRecords={totalRegistros}
                onFetchData={this.onFetchData.bind(this)}
                loading={loading}
                size="small"
                dataSource={registros}
                columns={this.columnasRegistros()}
                rowKey={(r) => r._id?.toString()}
              />
            </div>
          </Spin>
        </Form>

        <ModalVerRegistroProceso
          visible={this.state.modalVerRegistroPdf}
          registroId={this.state.registroIdPdf}
          onCancel={() => this.setState({ modalVerRegistroPdf: false, registroIdPdf: null })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ReporteColaborador);
